import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import MuiInputTextWithRemainingChars from '@shared/components/MuiInputTextWithRemainingChars';

/**
 * @typedef {object} FormInputWithRemainingCharsOwnProps
 * @property {string} name
 */

/**
 * @typedef {FormInputWithRemainingCharsOwnProps &
 *   React.ComponentProps<typeof MuiInputTextWithRemainingChars>} FormInputWithRemainingCharsProps
 */

/**
 * @param {FormInputWithRemainingCharsProps} props
 */
const FormInputWithRemainingChars = props => {
  const { name, ...otherProps } = props;

  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <MuiInputTextWithRemainingChars
          className='value'
          disableUnderline
          multiline
          rows={5}
          value={field.value}
          onChange={field.onChange}
          error={!!errors[name]}
          {...otherProps}
        />
      )}
    />
  );
};

export default FormInputWithRemainingChars;
